"use client";

import {CommerceProvider} from "provider/magento/context";
import {UIContext} from "../context";
import React from "react";
//import dynamic from "next/dynamic";
//import ProgressBar from "../Header/ProgressBar";
import LiveChat from "../LiveChat/LiveChat";
import NewLiveChat from "../NewLiveChat/NewLiveChat";

/*const CommerceProvider = dynamic(() => import('provider/magento/context').then(mod => mod.CommerceProvider), {ssr: false});
const UIContext = dynamic(() => import('../context').then(mod => mod.UIContext), {ssr: false});
const LiveChat = dynamic(() => import('../LiveChat/LiveChat'), {ssr: false});*/

const StorePage = ({header,footer,children,store, storeCode,_t}) => {

    return <CommerceProvider storeCode={storeCode}>
        <UIContext storeConfig={store}>
            {header}
            {children}
            {footer}
           {/* <LiveChat storeConfig={store} _t={_t}/>*/}
            <NewLiveChat storeConfig={store} _t={_t}/>
        </UIContext>
    </CommerceProvider>;
}

export default StorePage;